import {createSlice} from "@reduxjs/toolkit";
import moment from "moment/moment";

export const newDclInitialValue = {
    creationDateTime: moment().toDate(),
    installation: "0",
    clientServiceType: "",
    serviceCategory: "oneTime",
    fromAgreedPeriodDate: moment().format("DD/MM/YYYY"),
    toAgreedPeriodDate: "",
    mixedService: false,
    transmissionFailure: "",
    correlatedDclId: "",
    correlatedDclName: "",
    status: "open",
    comments: "",
    periodicity: "",
    periodicityOther: "",
    vehicleRegistrationNumber: "",
    vehicleCountry: "GR",
    vehicleCategory: "ΕΠΙΒΑΤΙΚΟ",
    vehicleFactory: "",
    vehicleMovementPurpose: "1",
    isDiffVehPickupLocation: false,
    vehiclePickupLocation: "",
    client: "",
    clientName: "",
    clientVatNumber: "",
    clientCountry: "",
    clientCategory: ""
}


const initialState = {
    newDcl: newDclInitialValue,
    editDcl: newDclInitialValue,
    selectedDcl: {},
    activeDcl: [],
    searchDcl: [],
    totalItemsDcl: 0,
    perPageDcl: 0,
    mainActiveDclLoader: false,
    showSelectedDclModal: false,
    showDclAfterSaleNew: false,
    showDclPageAfterSaleNew: false,
    refreshEditDcl: false,
    refreshSelectedDcl: false,
    dclRequestData: {
        forceRefresh: false,
        installation: "",
        clientServiceType: "",
        searchKeyword: "",
        dclStatus: "open"
    }
}

export const DclSlice = createSlice({
    name: "dcl",
    initialState,
    reducers: {
        setNewDcl: (state, {payload}) => {
            state.newDcl = payload;
        },
        setEditDcl: (state, {payload}) => {
            state.editDcl = payload;
        },
        resetNewDcl: (state) => {
            state.newDcl = newDclInitialValue;
        },
        setActiveDcl: (state, {payload}) => {
            state.activeDcl = payload;
        },
        setSearchDcl: (state, {payload}) => {
            state.searchDcl = payload;
        },
        setSearchDclTotalItems: (state, {payload}) => {
            state.totalItemsDcl = payload;
        },
        setSearchDclPerPage: (state, {payload}) => {
            state.perPageDcl = payload;
        },
        setDclRequestData: (state, {payload}) => {
            state.dclRequestData = payload;
        },
        setMainActiveDclLoader: (state, {payload}) => {
            state.mainActiveDclLoader = payload;
        },
        setSelectedDcl: (state, {payload}) => {
            state.selectedDcl = payload;
        },
        setShowSelectedDclModal: (state, {payload}) => {
            state.showSelectedDclModal = payload;
        },
        setShowDclAfterSaleNew: (state, {payload}) => {
            state.showDclAfterSaleNew = payload;
        },
        setShowDclPageAfterSaleNew: (state, {payload}) => {
            state.showDclPageAfterSaleNew = payload;
        },
        setRefreshEditDcl: (state, {payload}) => {
            state.refreshEditDcl = payload;
        },
        setRefreshSelectedDcl: (state, {payload}) => {
            state.refreshSelectedDcl = payload;
        },
        setForceRefreshDclActive: (state, {payload}) => {
            state.dclRequestData = {...state.dclRequestData, forceRefresh: payload};
        },
    }
});

export const {
    setNewDcl,
    setEditDcl,
    resetNewDcl,
    setActiveDcl,
    setSearchDcl,
    setSearchDclTotalItems,
    setSearchDclPerPage,
    setDclRequestData,
    setMainActiveDclLoader,
    setSelectedDcl,
    setShowSelectedDclModal,
    setShowDclAfterSaleNew,
    setForceRefreshDclActive,
    setShowDclPageAfterSaleNew,
    setRefreshEditDcl,
    setRefreshSelectedDcl
} = DclSlice.actions;
